<app-navbar></app-navbar>
<main class="content">
  <!-- Start Hero -->
  <section class="relative table w-full py-36 bg-[url('../../assets/images/bg/bg2.jpg')] bg-center bg-no-repeat">
    <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  </section><!--end section-->

  <div class="relative">
    <div class="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
      <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- End Hero -->

  <!-- Start -->
  <section class="relative md:py-24 py-16">
    <div class="container">
      <div class="grid md:grid-cols-12 gap-[30px]">
        <div class="lg:col-span-3 md:col-span-4">
          <div class="overflow-hidden rounded-md shadow dark:shadow-gray-800 sticky top-20">
            <div class="py-10 bg-[url('../../assets/images/blog/05.jpg')] bg-center bg-no-repeat"></div>

            <div class="relative text-center -mt-10 p-6 pt-0">
              <img [src]="'assets/images/avatar/1.jpg'" class="bg-white dark:bg-slate-900 h-20 w-20 rounded-full shadow-md dark:shadow-gray-800 mx-auto p-1" alt="">

              <div class="mt-3">
                <a [routerLink]="'/creator-profile'" class="font-semibold block hover:text-violet-600">{{ user?.name ?? user?.email }}</a>
                <span class="text-slate-400 text-sm block mt-1">&#64;{{ user?.preferredUsername }}</span>
              </div>

              <ul class="list-none sidebar-nav mb-0 mt-3" id="navmenu-nav">
                <li class="navbar-item account-menu text-[16px]">
                  <a [routerLink]="'/settings/profile'" class="navbar-link text-slate-400 flex items-center py-2 rounded">
                    <span class="me-2 mb-0"><i class="uil uil-dashboard"></i></span>
                    <h6 class="mb-0 font-medium">Profile</h6>
                  </a>
                </li>

                <li class="navbar-item account-menu text-[16px] ms-0">
                  <a [routerLink]="'/settings/general'" class="navbar-link text-slate-400 flex items-center py-2 rounded">
                    <span class="me-2 mb-0"><i class="uil uil-setting"></i></span>
                    <h6 class="mb-0 font-medium">Settings</h6>
                  </a>
                </li>

                <li class="navbar-item account-menu text-[16px] ms-0">
                  <a [routerLink]="'/settings/general'" class="navbar-link text-slate-400 flex items-center py-2 rounded">
                    <span class="me-2 mb-0"><i class="uil uil-lock-access"></i></span>
                    <h6 class="mb-0 font-medium">Multi-factor auth</h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="lg:col-span-9 md:col-span-8">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div><!--end container-->
  </section><!--end end section-->
  <!-- End -->
</main>
<app-footer></app-footer>
<app-scroll-to-top></app-scroll-to-top>
<app-switcher></app-switcher>
